<div class="container" role="main">
    <div class="HmsContainer">
        <form class="validateParticipantForm" [formGroup]="validateParticipantForm"
            (ngSubmit)="validateParticipantDetailsSubmit()">
            <div class="row">
                <div class="row HmsInsideContainer">
                    <div class="col-md-12 button-padding-left">
                        <button type="button" class="greyBtn" (click)="back()" style="font-weight : bold;">Go to
                            Previous
                            Section</button>
                        <button type="button" class="greyBtn ml-5" *ngIf="isInstruction" (click)="openInstruction()"
                            style="font-weight : bold;">Instructions</button>
                        <button type="submit" class="orangeBtn ml-5" *ngIf="validateParticipantForm.valid" [ngStyle]="{'background-color': primaryColor}">Proceed
                            to Next Section</button>
                    </div>
                </div>
                <div class="row HmsInsideContainer py-0">
                    <div class="col-md-12 button-padding-left">
                        <p role="heading" aria-level="1">Please enter responses to the question(s) below</p>
                    </div>
                </div>
            </div>
            <div class="row HmsInsideContainer">
                <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                    <div class="col-md-10">
                        <app-json-form [controlsData]="validateParticipantFormData.controls"
                            (valueChangeEvent)="valueChangeEvent($event)" 
                            [formData]="validateParticipantForm"></app-json-form>
                        <div *ngIf="validateParticipantForm.get('vpIsParticipant')?.value == 'Yes'">
                            <app-json-form *ngIf="validateParticipantForm.get('vpIsParticipant')?.value == 'Yes' 
                            && isExternalReferral"
                                (valueChangeEvent)="valueChangeEvent($event)"
                                [controlsData]="validateParticipantFormData.subcontrols"
                                [formData]="validateParticipantForm"></app-json-form>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>